import { DotGroup } from 'pure-react-carousel'
import styled from 'styled-components'

export const BundleBannerWrapper = styled.div`
  flex: 0 0 97%;
`

export const BundleBannerImage = styled.img`
  border-radius: 10px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
`

export const Dots = styled(DotGroup)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 11px;
  gap: 6px;

  & button {
    box-sizing: border-box;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    border: none;
    flex-shrink: 0;
    flex-grow: 0;
    background: #cecece;
    padding: 0;
    margin: 0;

    &:disabled {
      background: #ff5e6d;
    }
  }
`
